<template>
  <div class="notifications-container">
    <div
      class="notification-item-container"
      :class="{'notification-item-unread-container': item.isUnread}"
      v-for="(item, index) in notificationList"
      :key="`notificationList_${index}`">
      <div class="notification-item-rectangle"></div>
      <div class="notification-item-top">
        <div class="notification-item-title">{{ item.title }}</div>
        <div class="notification-item-time">{{ getLastActionDate(item.updateTime || item.createdTime)}}</div>
      </div>
      <div class="notification-item-des">
        {{ item.description }}
      </div>
    </div>
  </div>
</template>

<script>
const curDate = new Date()
const curDate1 = new Date(curDate).toISOString()
const curDate2 = new Date(curDate - (1000 * 60 * 60)).toISOString()
const curDate3 = new Date(curDate - (1000 * 60 * 60 * 24)).toISOString()

export default {
  name: "notifications",
  data() {
    return {
      notificationList: []
    }
  },
  methods: {
    // 获取相差几天或者几小时或者几分钟
    getLastActionDate(value) {
      if (!value) {
        return ''
      }
      const currentDate = Date.now()
      const upDate = new Date(value).getTime()
      const diffNum = currentDate - upDate

      const oneMin = 1000 * 60
      const oneHour = oneMin * 60
      const oneDay = oneHour * 24
      // 相差多少天
      const diffDays = parseInt(diffNum / oneDay)
      if (diffDays > 0) {
        return `${diffDays} ${this.$t('days_ago')}`
      }
      // 相差多少小时
      const diffHours = parseInt(diffNum / oneHour)
      if (diffHours > 0) {
        return `${diffHours} ${this.$t('hours_ago')}`
      }
      // 相差多少分钟
      const diffMins = parseInt(diffNum / oneMin)
      return `${diffMins} ${this.$t('mins_ago')}`
    }
  }
}
</script>

<style lang="less">
.notifications-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .notification-item-container {
    width: 100%;
    height: 84px;
    margin: 1px 0 0;
    padding: 21px 24px 1px 37px;
    position: relative;
    background-color: rgba(216, 216, 216, 0.25);

    .notification-item-top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .notification-item-title {
        font-family: 'Source Sans Pro';
        font-size: 16px;
        font-weight: 900;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.75;
        letter-spacing: normal;
        color: #d8d8d8;
        margin-bottom: 10px;
      }
      .notification-item-time {
        font-family: SourceSansPro-It;
        font-size: 8px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #d8d8d8;
      }
    }

    .notification-item-des {
      font-family: 'Source Sans Pro';
      font-size: 12px;
      font-weight: 900;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.75;
      letter-spacing: normal;
      color: #d8d8d8;
    }
  }

  .notification-item-unread-container {
    background-color: #FFFFFF;

    .notification-item-rectangle {
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 100%;
      background-color: #7CC26A;
    }

    .notification-item-top {
      .notification-item-title {
        color: #041f1f;
      }
      .notification-item-time {
        color: #8ba39e;
      }
    }

    .notification-item-des {
      color: #041f1f;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Profile/notifications.vue